import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const DEFAULT_STATUS_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

/**
 * Standardized status filter dropdown.
 *
 * - Keeps filtering logic in parent (this is UI only).
 * - Supports custom option values (string/number) via `options`.
 */
const StatusDropdown = ({
  value,
  onChange,
  label = "Status",
  options = DEFAULT_STATUS_OPTIONS,
  size = "small",
  sx,
  fullWidth = false,
  disabled = false,
}) => {
  return (
    <FormControl size={size} sx={sx} fullWidth={fullWidth} disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={(e) => onChange?.(e.target.value)}
      >
        {options.map((opt) => (
          <MenuItem key={String(opt.value)} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StatusDropdown;
export { DEFAULT_STATUS_OPTIONS };

